var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
  content: _vm.tooltipcontent,
  classes: ['info'],
}),expression:"{\n  content: tooltipcontent,\n  classes: ['info'],\n}"}],staticClass:"marker"},[_c('div',{staticClass:"icon-label",on:{"click":function($event){return _vm.onClick()}}},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.index + 1))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }